
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/beoordelingen",
      function () {
        return require("private-next-pages/[region]/[resort]/beoordelingen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/beoordelingen"])
      });
    }
  